module.exports = "images/miscellaneous_d.c7a8115957bb091ca9206508413b25ef.png";